/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import validation from './validation';
import styles from './styles.module.scss';
import logoImg from '../../assets/images/logo.svg';
import Button from '../../components/Button';
import InputText from '../../components/FormInputText';
import keys from '../../config/keys';
import actions from '../../redux/actions';
import { getIsLoading } from '../../redux/reducers/auth';

import type { Translate, ReduxState } from '../../types';

type FormValues = {
  username: string,
  password: string,
};

type Props = {
  isLoading: boolean,
  login: (username: string, password: string) => mixed,
  forgotUrl: string,
  valid: boolean,
  pristine: boolean,
  handleSubmit: (callback: mixed) => any,
  t: Translate,
  router: mixed,
  username?: string,
  password?: string,
} & FormProps;

const mapStateToProps = (state: ReduxState) => ({
  isLoading: getIsLoading(state),
});

class LoginForm extends React.Component<Props, void> {
  componentDidMount() {
    document.addEventListener('keydown', this._handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleKeyDown, false);
  }

  componentDidUpdate(prevProps: Props) {
    const { username, password } = this.props;
    if (!_.isEqual(prevProps.username, username)) {
      this.props.change('username', username);
    }
    if (!_.isEqual(prevProps.password, password)) {
      this.props.change('password', password);
    }
  }

  _handleKeyDown = (event: any) => {
    if ((event.keyCode || event.which) === 13) {
      this.props.handleSubmit(this._handleLoginClick)();
    }
  };

  _handleLoginClick = ({ username, password }: FormValues) => {
    this.props.login(username, password);
  };

  render() {
    const { forgotUrl, isLoading, handleSubmit, valid, pristine, t } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.form}>
          <div className={styles.logo}>
            <img src={logoImg} className={styles.logo} alt={'Logo'} />
          </div>
          <Field
            component={InputText}
            name={'username'}
            label={t('USERNAME')}
            disabled={isLoading}
          />
          <Field
            component={InputText}
            name={'password'}
            label={t('PASSWORD')}
            type={'password'}
            disabled={isLoading}
          />
          <a className={styles.forgot} href={forgotUrl}>
            {t('FORGOT_PASSWORD')}
          </a>
          <div className={styles.formButton}>
            <Button
              text={t('LOGIN')}
              onClick={handleSubmit(this._handleLoginClick)}
              disabled={isLoading || !valid || pristine}
              loading={isLoading}
              appearance={'jarvis'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    mapStateToProps,
    actions
  )(
    reduxForm({
      form: 'login',
      validate: validation,
      //$FlowFixMe
      destroyOnUnmount: !(keys.IS_ENV_DEVELOPMENT && module.hot),
    })(LoginForm)
  )
);
